import * as paymentActions from 'client/actions/paymentActions'
import { wrapFontFamily } from 'common/components/entities/Text/utils'
import { NotFound } from 'common/errors'
import { NetworkError } from 'common/errors/NetworkError'
import PropTypes from 'prop-types'
import React, { memo, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useCalculateTypography } from 'src/editor/shared/hooks/use-calculate-typography'
import { fetchOfferData } from '../api/paymentApi'
import usePageRouteDetector from '../hooks/usePageRouteDetector'
import { ActivePopup } from './components/popup/active-popup'
import PageUi from './ui/PageUi'

function PaymentPage({ children }) {
  const dispatch = useDispatch()
  const { globalFontFamily, globalFontStyle, globalFontWeight } =
    useCalculateTypography()
  const { pageId, isTemplate } = usePageRouteDetector()

  useEffect(() => {
    if (isTemplate) {
      return
    }

    ;(async () => {
      try {
        const { data } = await fetchOfferData(pageId)
        dispatch(paymentActions.fetchPaymentDataSuccess(data))
      } catch (error) {
        if (error instanceof NotFound) {
          // do nothing
        } else if (error instanceof NetworkError) {
          // do nothing, we have stub data
        } else {
          // do nothing
        }
      }
    })()
  }, [])

  return (
    <PageUi
      fontFamily={wrapFontFamily(globalFontFamily)}
      fontWeight={globalFontWeight}
      fontStyle={globalFontStyle}
    >
      {children}
      <ActivePopup />
    </PageUi>
  )
}

PaymentPage.propTypes = {
  children: PropTypes.node.isRequired,
}

export default memo(PaymentPage)
